<template>
  <div>
    <div class="row">
      <div class="col-lg-6 mb-2" v-show="tieneAlias('Dato auxiliar 1')">
        <label for="datoaux1">{{ cargarAliasCampo('Dato auxiliar 1') }}</label>
        <input
          type="text"
          name="datoaux1"
          class="form-control"
          v-model="localCliente.datoaux1"
          placeholder="Dato auxiliar 1"
          autocomplete="off"
          maxlength="500"
          @input="actualizarCliente()"
        />
      </div>
      <div class="col-lg-6 mb-2" v-show="tieneAlias('Dato auxiliar 2')">
        <label for="datoaux2">{{ cargarAliasCampo('Dato auxiliar 2') }}</label>
        <input
          type="text"
          name="datoaux2"
          class="form-control"
          v-model="localCliente.datoaux2"
          placeholder="Dato auxiliar 2"
          autocomplete="off"
          maxlength="500"
          @input="actualizarCliente()"
        />
      </div>
      <div class="col-lg-6 mb-2" v-show="tieneAlias('Dato auxiliar 3')">
        <label for="datoaux3">{{ cargarAliasCampo('Dato auxiliar 3') }}</label>
        <input
          type="text"
          name="datoaux3"
          class="form-control"
          v-model="localCliente.datoaux3"
          placeholder="Dato auxiliar 3"
          autocomplete="off"
          maxlength="500"
          @input="actualizarCliente()"
        />
      </div>
      <div class="col-lg-6 mb-2" v-show="tieneAlias('Dato auxiliar 4')">
        <label for="datoaux4">{{ cargarAliasCampo('Dato auxiliar 4') }}</label>
        <input
          type="text"
          name="datoaux4"
          class="form-control"
          v-model="localCliente.datoaux4"
          placeholder="Dato auxiliar 4"
          autocomplete="off"
          maxlength="500"
          @input="actualizarCliente()"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CmpOtros',
  props: ["cliente", "tieneAlias", "cargarAliasCampo"],
  data() {
    return {
      localCliente: {}
    }
  },
  watch: {
    cliente: {
      deep: true,
      immediate: true,
      handler(val) {
        this.localCliente = JSON.parse(JSON.stringify(val))
      }
    }
  },
  methods: {
    actualizarCliente: function() {
      var self = this
      self.$emit("update:cliente", JSON.parse(JSON.stringify(this.localCliente)))
    }
  }
}
</script>

<style scoped>
</style>